// 画面の高さに応じてアニメーションを適用させる処理
const screenHeight = window.innerHeight;
const appearPoint = screenHeight * 0.8;

window.addEventListener('scroll', () => {
  const box = document.querySelectorAll('.fadeIn, .textanimation');

  for (let i = 0; i < box.length; i++) {
    const element = box[i];
    const elementHeightToTop = element.getBoundingClientRect().top;

    if (elementHeightToTop < appearPoint) {
      element.classList.add('active');
    } else {
      element.classList.remove('');
    }
  }
});

//購入ボタンのアニメーション処理
$(function () {
  $('.buy')
    .on('mouseenter', function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find('span').css({ top: relY, left: relX });
    })
    .on('mouseout', function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find('span').css({ top: relY, left: relX });
    });
});

//テキストを一文字ずつ表示するアニメーション処理
const animationTargetElements = document.querySelectorAll('.textanimation');
for (let i = 0; i < animationTargetElements.length; i++) {
  const targetElement = animationTargetElements[i];
  texts = targetElement.textContent;
  textsArray = [];

  targetElement.textContent = '';

  for (let j = 0; j < texts.split('').length; j++) {
    textsArray.push(
      '<span><span style="animation-delay: ' +
        (j + 2) * 0.2 +
        's" >' +
        texts.split('')[j] +
        '<span></span>'
    );
  }
  for (let k = 0; k < textsArray.length; k++) {
    targetElement.innerHTML += textsArray[k];
  }
}
